export enum SalonModulesEnum {
    Reviews = 0,
    Website = 1,
    OnlineBooking = 2
}
